import { Link } from 'react-router-dom'
import { Section } from '@vanilla/ui'

export function VoxNote() {
  return (
    <Section className="py-20 md:py-32">
      <div className="flex flex-col items-center text-center">
        {/* Logo placeholder */}
        <div className="relative mb-8 h-24 w-24">
          <div
            className="absolute left-6 top-10 h-12 w-5 rounded-lg"
            style={{ background: '#FF6B4A' }}
          />
          <div
            className="absolute left-9 top-6 h-5 w-12 rounded-lg"
            style={{ background: '#FF6B4A' }}
          />
        </div>

        <h1
          className="mb-4 text-4xl font-bold tracking-tight sm:text-5xl"
          style={{
            background: 'linear-gradient(135deg, #FF6B4A, #FF8A70)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          VoxNote
        </h1>

        <p className="mb-10 max-w-md text-lg text-muted-foreground">
          Capture thoughts with your voice. AI automatically cleans up and formats your notes.
        </p>

        {/* Features */}
        <div className="mb-10 grid gap-8 sm:grid-cols-3">
          <div className="text-center">
            <span className="mb-3 block text-3xl">🎙️</span>
            <h3 className="mb-1 font-semibold">Voice First</h3>
            <p className="text-sm text-muted-foreground">
              Just tap and talk. On-device transcription works offline.
            </p>
          </div>
          <div className="text-center">
            <span className="mb-3 block text-3xl">✨</span>
            <h3 className="mb-1 font-semibold">AI Refinement</h3>
            <p className="text-sm text-muted-foreground">
              Removes filler words, adds punctuation, formats beautifully.
            </p>
          </div>
          <div className="text-center">
            <span className="mb-3 block text-3xl">🔒</span>
            <h3 className="mb-1 font-semibold">Private by Design</h3>
            <p className="text-sm text-muted-foreground">
              Your notes stay on your device and your iCloud.
            </p>
          </div>
        </div>

        {/* Links */}
        <div className="flex gap-6">
          <Link
            to="/labs/apps/voxnote/privacy"
            className="text-primary hover:underline"
          >
            Privacy Policy
          </Link>
          <Link
            to="/labs/apps/voxnote/support"
            className="text-primary hover:underline"
          >
            Support
          </Link>
          <Link to="/labs" className="text-primary hover:underline">
            KHC Labs
          </Link>
        </div>

        <p className="mt-16 text-sm text-muted-foreground">
          © 2025 KHC Labs. All rights reserved.
        </p>
      </div>
    </Section>
  )
}
